import * as Yup from "yup";

const extractRequiredFields = (yupObject: any): Record<string, boolean> => {
  // @ts-ignore
  const innerFields = Object.keys(yupObject.fields);
  const result: Record<string, boolean> = {};
  // @ts-ignore
  innerFields.forEach(field => {
    // @ts-ignore
    yupObject.fields[field].exclusiveTests["required"]
      ? (result[field] = true)
      : (result[field] = false);
  });

  return result;
};

export default extractRequiredFields;
